import { Service } from '@genial/services';
import { InitOverrideFunction } from '@genial/services/dist/runtime';

import { screenName } from '../../../store/batchTicketInvestLink/constants';

export const postTfaCodeService = async (basketCustomerId: string, tfaCode: string) => {
  const initOverrideFunction: InitOverrideFunction = async ({ init }) => {
    const headers = new Headers(init.headers);
    headers.append('Authorization', '');

    return {
      ...init,
      headers,
    };
  };
  const { data, statusCode } = await Service.Authentication.V1.postTfaTokenBasketCustomerValidate(
    {
      screenName,
      validateBasketTfaTokenRequest: {
        basketCustomerId,
        tfaCode,
      },
    },
    initOverrideFunction
  );

  if (statusCode === 200) {
    return data;
  }

  throw new Error('Não foi possível processar a requisição.');
};
